import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

export class RemoveBuildingAttributeCommand extends CommandBase {
    unitId: string;
    attribute: string;

    constructor(unitId: string, attribute: string) {
        super();
        this.unitId = unitId;
        this.attribute = attribute;
    }

    execute(state: RemoteConstantsModel): boolean {
        const index = state.buildings.findIndex(u => u.id === this.unitId);
        if (index < 0) {
            return false;
        }

        const attributeIndex =  state.buildings[index].attributes.findIndex(a => a === this.attribute);
        if (attributeIndex < 0) {
            return false;
        }

        state.buildings[index].attributes.splice(attributeIndex, 1);
        return true;
    }
}